import script from "./UpperHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpperHeader.vue?vue&type=script&lang=ts&setup=true"

import "./UpperHeader.vue?vue&type=style&index=0&id=90da370c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90da370c"]])

export default __exports__